import { Controller } from "@hotwired/stimulus"

// Handles flash message animations and auto-removal
export default class extends Controller {
  connect() {
    console.log("[Flash] Controller connected", this.element);
    
    // Initially hide the element
    this.element.style.opacity = '0'
    
    // Add animate.css base class
    this.element.classList.add('animate__animated')
    
    // Start fade in after a brief delay and remove the initial opacity
    setTimeout(() => {
      this.element.style.removeProperty('opacity')
      this.element.classList.add('animate__fadeIn')
    }, 100)

    // Auto-remove after 5 seconds
    setTimeout(() => {
      // Remove fade in and add fade out
      this.element.classList.remove('animate__fadeIn')
      this.element.classList.add('animate__fadeOut')
      
      // Add event listener for animation end
      this.element.addEventListener('animationend', this.remove.bind(this), { once: true })
    }, 5000)
  }

  remove() {
    // Only remove if it was a fade-out animation
    if (this.element.classList.contains('animate__fadeOut')) {
      this.element.remove()
    }
  }
} 